import {RemoteGetAuthDetail} from 'data/usecases/private/authorizations';
import {GetAuthDetail} from 'domain/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthDetail = (nuControle: number): GetAuthDetail =>
	new RemoteGetAuthDetail(
		makeBFFApiUrl(`${AuthorizationsFlowEndpoints.detail}/${nuControle}`),
		makeAuthorizeHttpClientDecorator(),
	);
